import { useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import AddLinkModal from 'hb-react/shared/components/DesignSystem/QuillEditor/AddLinkModal';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';

import ToolbarItem from '../components/ToolbarItem';

const Link = () => {
  const {
    displayLinkModal,
    setDisplayLinkModal,
    options,
    setForceEditorFocus,
  } = useQuillEditorContext();

  const { tooltips: tooltipsOptions } = options ?? {};

  const openAddLinkModal = useCallback(() => {
    setDisplayLinkModal?.(true);
  }, [setDisplayLinkModal]);

  return (
    <>
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={openAddLinkModal}
        icon={<FontAwesomeIcon iconName="link-simple" height="16px" />}
        dataTestId="links-action"
        ariaLabel={s__('QuillEditorAccessibility|Add a link')}
        tooltip={tooltipsOptions?.links}
        enableFontAwesomeIcon
      />
      {displayLinkModal && (
        <AddLinkModal
          isOpen={displayLinkModal}
          onClose={() => setDisplayLinkModal?.(false)}
        />
      )}
    </>
  );
};

export default Link;
